export class OrderCreditAssessmentBuilder {
    constructor() {
        this.properties = {};
    }
    withScoreId(scoreId) {
        this.properties.scoreId = scoreId;
        return this;
    }
    withFinancialProductCode(code) {
        this.properties.financialProductCode = code;
        return this;
    }
    withRecommendation(recommendation) {
        this.properties.recommendation = recommendation;
        return this;
    }
    withDecision(decision) {
        this.properties.decision = decision;
        return this;
    }
    build() {
        return this.properties;
    }
}
